import i18n from '@/i18n';
import translateGeneral from '@/services/validation/translator';
import erreurChampsVide from './erreurChampsVide';
import { erreurStringLength, STRING_LENGTH } from './erreurStringLength';
import { erreurRange, RANGE } from './erreurRange';

export function removeDuplicateMsgError(messages) {
  if (!Array.isArray(messages) || !messages.length) return [];
  const copieMessages = messages.map(msg => ({ msg, id: i18n.t(msg.message, msg.parametres) }));
  const uniqueIds = [...new Set(copieMessages.map(el => el.id))];
  return uniqueIds.map(id => copieMessages.find(el => el.id === id).msg);
}

export function errorViolatesForeignKeyManager(message, messages) {
  if (message.includes('violates foreign key constraint')) {
    const regex = /\b((commun_t_|gabed_t_|gescom_t_)\w+)\b/gm;
    const match = message.match(regex);
    if (i18n.t(`parametrage.tables.${match[1]}`) === `parametrage.tables.${match[1]}`) {
      messages.push({ message: 'general.messages.error.violatesForeignKeyNoTranslate' });
    } else {
      messages.push({
        message: 'general.messages.error.violatesForeignKey',
        parametres: {
          table: i18n.t(`parametrage.tables.${match[1]}`),
        },
      });
    }
  }
}

export default function validation(i18n, response, champsVide, messages, messagesChampsVide,
  translate) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    if (response.data && response.data.error && response.data.error.message === 'Exception of type \'Abp.Domain.Entities.EntityNotFoundException\' was thrown.') {
      messages.push({ message: 'validation.notAccess' });
    }
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    let champs = 0;
    if (error.members) {
      champs = error.members[0];
      if (translate) champs = translate(i18n, champs);
      champs = translateGeneral(i18n, champs);
    }
    const message = error.message;
    const numLigne = message.split('__');
    let preMessage = null;
    if (numLigne[1]) {
      preMessage = { message: 'importDonne.numLigne', parametres: { num: numLigne[1] } };
    }
    if (!message || message.endsWith(' field is required.')
      || message.startsWith('Cannot convert null')
      || message.startsWith('Error converting value {null}')) {
      erreurChampsVide(champsVide, champs, messagesChampsVide);
    }
    if (message.indexOf(STRING_LENGTH) !== -1 && champs) {
      erreurStringLength(message, champs, messages, preMessage);
    }
    if (message.indexOf(RANGE) === 0) {
      erreurRange(message, champs, messages, preMessage);
    }
    if (/Input string '.*' is not a valid integer/g.test(message) && champs) {
      messages.push({ message: 'validation.fieldIsNotInteger', parametres: { name: champs } });
    }
    if (/Input string '.*' is not a valid decimal/g.test(message) && champs) {
      messages.push({ message: 'validation.fieldIsNotDecimal', parametres: { name: champs } });
    }
    if (/Input string '.*' is not a valid decimal/g.test(message) && champs) {
      messages.push({ message: champs });
    }
    if (message.indexOf('The Name field is required') === 0) {
      messages.push({
        message: 'validation.libelleObligatoire',
        preMessage,
      });
    }
    if (message.indexOf('DATE_WITHOUT_TIME') === 0) {
      messages.push({
        message: 'validation.formatDate.withoutTime',
        parametres: {
          name: champs,
        },
        preMessage,
      });
    }
    if (message.indexOf('DECIMAL') === 0) {
      messages.push({
        message: 'validation.decimal',
        parametres: {
          name: champs,
        },
        preMessage,
      });
    }
    if (message.indexOf('DATE_REQUIRED') === 0) {
      messages.push({
        message: 'validation.dateRequired',
        parametres: {
          name: champs,
        },
        preMessage,
      });
    }
    if (message.indexOf('ADDRESS_REQUIRED') === 0) {
      messages.push({
        message: 'validation.addressRequired',
        preMessage,
      });
    }
    if (message.indexOf('ADDRESS_WRONG_FORMAT') === 0) {
      messages.push({
        message: 'validation.addressWrongFormat',
        preMessage,
      });
    }
    if (message.indexOf('ADDRESS_WITH_INTITULE_WRONG_FORMAT') === 0) {
      messages.push({
        message: 'validation.addressWithIntituleWrongFormat',
        preMessage,
      });
    }
    if (message.indexOf('EXACTLY_ONE_ACCOUNTING_RECIPIENT') === 0) {
      messages.push({
        message: 'validation.destCompt',
        preMessage,
      });
    }
    if (message.indexOf('REMAINDER_TO_SETTLE_LESS_ZERO') === 0) {
      messages.push({
        message: 'validation.amountGreaterThanMouvements',
        preMessage,
      });
    }
    if (message.indexOf('SIGNATURE_REQUEST_WAS_NOT_PASSED') === 0) {
      messages.push({
        message: 'validation.requestWasNotPassed',
        preMessage,
      });
    }
    if (message.indexOf('SECTEUR_LINKED') === 0) {
      messages.push({
        message: 'addEditSecteur.validations.secteurLinked',
      });
    }
    if (message.indexOf('START_DATE_GREATER_THAN_END_DATE') === 0) {
      messages.push({
        message: 'validation.dateDebutGreaterDateFin',
      });
    }
    if (message.indexOf('STRING_LENGTH_INVALID') === 0) {
      messages.push({
        message: 'general.messages.error.addPieceJointeLengthError',
      });
    }
    if (message.indexOf('STRING_LENGTH_URL_INVALID') === 0) {
      messages.push({
        message: 'general.messages.error.getPieceJointeLengthError',
      });
    }
  });
}
